module.exports = __webpack_public_path__ + "static/media/sidebar-2.d30c9e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-2.jpg
// module id = 1067
// module chunks = 0